"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapboxResult = exports.PeliasResult = void 0;
const provider_1 = __importDefault(require("./mapbox/provider"));
const provider_2 = __importDefault(require("./pelias/provider"));
const result_1 = __importDefault(require("./mapbox/result"));
exports.MapboxResult = result_1.default;
const result_2 = __importDefault(require("./pelias/result"));
exports.PeliasResult = result_2.default;
const locate_me_1 = __importDefault(require("./locate_me"));
class LocationControl {
    constructor({ provider = "mapbox", apiKey, locationType, language, country, baseUrl, debounce = 300, }) {
        this.locateMe = (callback) => {
            const locate = new locate_me_1.default(this.locationProvider, callback);
            return locate.perform();
        };
        this.locationProvider =
            provider === "mapbox"
                ? new provider_1.default({
                    apiKey,
                    locationType,
                    language,
                    country,
                })
                : new provider_2.default({ apiKey, locationType, baseUrl });
        this.locationType = locationType;
        this.debounce = debounce;
    }
    results(term) {
        clearTimeout(this.timer);
        return new Promise((resolve) => {
            this.timer = setTimeout(() => {
                resolve(this.locationProvider.geocode(term));
            }, this.debounce);
        });
    }
    resultSelected(selectResult) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.locationProvider.resultSelected(selectResult);
        });
    }
}
exports.default = LocationControl;
